import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'antd';
import ReactStars from "react-rating-stars-component";

function CloseChatPopup(props) {
  const [ratingChangedText, setRatingChangedText] = useState();
  const [rating, setRating] = useState(props.rating);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    props.changeShow("no");
  }
  useEffect(() => {
    if(rating !== undefined)
      setRatingChangedText(rating + ": " + getRatingText(rating));
    console.log('Prop passed is:-', props.show);
    setShow(props.show);
  }, []);

  const handleYes = () => {
    setShow(false);
    props.surveryTrigger(rating);
    props.changeShow("yes");
  }

  const getRatingText = (rating) =>{
    if(rating == 1){
      return "Very dissatisfied";
    }else if(rating == 2){
      return "Dissatisfied";
    }else if(rating == 3){
      return "Neutral";
    }else if(rating == 4){
      return "Satisfied";
    }else if(rating == 5){
      return "Very satisfied";
    }
  }


  const ratingChanged = (newRating) => {
    if(newRating){
      setRatingChangedText(newRating + ": " + getRatingText(newRating));
      setRating(newRating)
      props.surveryTrigger(newRating);
    }    
    console.log(newRating);
  };

  
  return (
    <>
      <Modal
        // title="Optional survey and close chat"
        // title="Are you sure you want to close the chat window?"
        title="Give rating and end chat"
        centered
        visible={show}
        onOk={handleYes}
        onCancel={handleClose}
        footer={[
            <Button key="submit" type="primary" onClick={handleYes}>
              Yes,&nbsp;end chat
            </Button>,
            <Button key="back" className ="ant-btn-default" onClick={handleClose}>
              No,&nbsp;continue
            </Button>,
          ]}
          maskClosable={false}
          closeIcon={<>
                        <i aria-label="icon: close" class="anticon anticon-close ant-modal-close-icon">
                          <svg viewBox="64 64 896 896" focusable="false" class="" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true" style={{color: '#0074AD'}}><path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path></svg>
                      <p className="ant-close-icon">Close</p></i>
                    </>}
        >
          <div class="survey-modal-header">
            Optional Survey
          </div>
          <p class="survey-modal-content">
            Overall, how satisfied were you with this chat experience?
          </p>
          <div style={{ display:'inline-flex'}}>
            <ReactStars
              value={rating}
              count={5}
              onChange={ratingChanged}
              size={24}
              activeColor="#013B71"
            />
            <div style={{ float:"right", fontSize:16, margin:6, fontFamily:"Gotham", color:"#0D1C3D;", fontWeight:325}}> {ratingChangedText} </div>
          </div>
          {/*<br></br>
          <div class="survey-modal-header">
            Did you mean to click end chat?
          </div>*/}
          <br></br>
          <p class="survey-modal-content-end-chat">Are you sure you want to end the chat?</p> 
           {/*<p>This will end your current chat session.</p>*/}
      </Modal>
    </>
  );
}

export default CloseChatPopup;
